import { useIntl } from "react-intl";
import { Disclosure } from "@/components/design/Disclosure";
import type { MatchData } from "../match-design-types";
import { ExpertiseSection } from "./ExpertiseSection";
import { DetailsSection, DETAIL_TYPES } from "./DetailsSection";
import { RecruitingExperience } from "./RecruitingExperience";
import { RecruitingQualifications } from "./RecruitingQualifications";

export function RoleRequirementsPanel({ data, update, readOnly, className, id }: {
  data: MatchData;
  update: (patch: Partial<MatchData>) => void;
  readOnly: boolean;
  className?: string;
  id?: string;
}) {
  const intl = useIntl();
  return (
    <Disclosure id={id} className={className} title={intl.formatMessage({ id: "match.roleReqsSection" })} defaultOpen>
      <div className="space-y-6">
        <ExpertiseSection data={data} update={update} readOnly={readOnly} />
        <DetailsSection conditions={data.conditions.filter((c) => DETAIL_TYPES.has(c.__typename))}
          onChange={(next) => update({ conditions: [...data.conditions.filter((c) => !DETAIL_TYPES.has(c.__typename)), ...next] })}
          showRequirement singlePerson readOnly={readOnly} />
        <RecruitingExperience data={data} update={update} readOnly={readOnly} />
        <RecruitingQualifications data={data} update={update} readOnly={readOnly} />
      </div>
    </Disclosure>
  );
}
